<template>
  <div class="section">
    <div class="container" spaced>
      <!-- {{ $t("translation1") }}
      <input id="head" v-model="chosenColor" type="color" value="#e66465" /> -->
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  components: {},
  data() {
    return {
      chosenColor: this.$store.getters.getPrimaryColor,
    };
  },
  watch: {
    chosenColor: {
      handler() {
        this.changeColorScheme();
      },
    },
  },
  created() {
    if (
      typeof this.$store.getters.getOrganizationId == "undefined" ||
      this.$store.getters.getOrganizationId.length == 0
    ) {
      this.$router.push({ name: "Login" });
    } else {
      this.$router.push({
        name: "Dashboard",
        params: { organizationId: this.$store.getters.getOrganizationId },
      });
    }
    if (window.location.hostname === "goqonda.io") {
      window.location.replace("https://goqonda.io");
    }
  },
  methods: {
    changeColorScheme() {
      this.$store.commit("changeColorScheme", this.chosenColor);
    },
  },
};
</script>
